import { request } from '../../Common/api/client';

const BASE_PATH = '/api/cp/gasystem/customers';

export async function getGasystemCpCustomersCapability() {
  return request({ method: 'GET', url: `${BASE_PATH}/capability` });
}

export async function getGasystemCpCustomers({ page = 1, limit = 100, q = '' } = {}) {
  const query = String(q || '').trim();
  return request({
    method: 'GET',
    url: BASE_PATH,
    params: { page, limit, ...(query ? { q: query } : {}) },
  });
}

export async function getGasystemTerminalCustomers(
  terminalPkId,
  { page = 1, limit = 100, q = '', businessNo = '' } = {},
) {
  const customerNameQuery = String(q || '').trim();
  const businessNoQuery = String(businessNo || '').trim();
  return request({
    method: 'GET',
    url: `/api/cp/gasystem/terminals/${encodeURIComponent(terminalPkId)}/customers`,
    params: {
      page,
      limit,
      ...(customerNameQuery ? { q: customerNameQuery } : {}),
      ...(businessNoQuery ? { businessNo: businessNoQuery } : {}),
    },
  });
}
